import styled from 'styled-components';
import theme from './../../theme';

const Container = styled.div`
  display: flex;
  align-items: center;

  width: 100%;
  background-color: #f0f0f0; /* Cambia el color de fondo según tus preferencias */
  padding: 10px;
  justify-content: space-between;
`;

const Label = styled.label`
  text-align: right;
  margin-right: 50px; /* Agrega margen derecho para crear espacio */
`;

const InputContainer = styled.div`
  flex-grow: 1;
  display: flex;
  align-items: center;
  background-color: #fff; /* Cambia el color de fondo según tus preferencias */
  border-radius: 5px;
  padding: 5px;
  
`;

const SearchInput = styled.input`
  border: none;
  outline: none;
  flex-grow: 1;
  padding: 5px;
  
`;

const SearchButton = styled.button`
  background-color: ${theme.azul}; /* Cambia el color del botón según tus preferencias */
  color: #fff;
  border: none;
  border-radius: 5px;
  padding: 5px 10px;
  margin-left: 5px;

  &:hover {
    background: ${theme.colorPrimario};
  
}
`;

const ExportButton = styled.button`
  background-color: ${theme.verde}; /* Cambia el color del botón según tus preferencias */
  color: #fff;
  border: none;
  border-radius: 5px;
  padding: 5px 10px;
  margin-left: 5px;
 
  svg {
    width: 1.5rem; /* 18px */
    height: 1.5rem;
    fill: ${theme.grisClaro};
}
  &:hover {
    background: ${theme.grisClaro2};
    svg {
    
        fill: ${theme.verde};
    }
    color: ${theme.verde};
    }
    @media (max-width: 50rem) { /* 80px */
    opacity: 1;
}  
`;

const SearchIcon = styled.i`
  margin-right: 5px;
`;

const ExportIcon = styled.i`
  margin-right: 5px;
`;

const SelectAllCheckbox = styled.input`
  margin-right: 5px;
`;


export { Container, Label, InputContainer, SearchInput, SearchButton, ExportButton, SearchIcon, ExportIcon, SelectAllCheckbox };